import { reducer as form } from 'redux-form'
export default form
